export const APP_ACCESS = "app_access";
export const D_INV22G = "gestion_ent";
export const SGE_MODULE_NAME = "sge";
export const STORES_ACCESS = "stores_access";
export const DISPLAY = "display";
export const TOKEN = "token";
export const USER = "user";
export const USERNAME = "userName";
export const USER_PREFERENCES = "userPreferences";
export const SELECTED_WAREHOUSE = "selectedWarehouse";
